import { Flex, FormLabel, Grid } from '@chakra-ui/react'
import React from 'react'

interface LabelWithIconProps {
  label: string
  icon: React.ReactNode
}

export const LabelWithIcon = ({ label, icon }: LabelWithIconProps) => {
  return (
    <Flex
      sx={{
        gap: 6,
        width: '100%',
        alignItems: 'center',
      }}
    >
      <Grid sx={{ h: '2.25rem', alignContent: 'end' }}>{icon}</Grid>

      <FormLabel>{label}</FormLabel>
    </Flex>
  )
}
